import "./App.scss";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import Layout from "./modules/Layout/Layout";
import "./i18n";
import { Routes, Route, Navigate } from "react-router-dom";
import { useErrors, useIsLoading } from "./core/useIsLoading";
import { configAxios } from "./core/axiosInstance";
import { Alert, CircularProgress, Snackbar } from "@mui/material";
import ErrorMessage from "./core/ErrorMessage";
import { LicenseInfo } from "@mui/x-data-grid-pro";
import { useAuth } from "react-oidc-context";
import { RequireAuth } from "./modules/Auth/RequireAuth";
import LoginCallback from "./modules/Login/LoginCallback";
import LogoutCallback from "./modules/Logout/LogoutCallback";

function App() {
  LicenseInfo.setLicenseKey(process.env.REACT_APP_LICENSE);
  const loadingHook = useIsLoading();
  const errorHook = useErrors();

  configAxios(loadingHook, errorHook);

  const auth = useAuth();

  switch (auth.activeNavigator) {
    case "signinSilent":
      return <div>Signing you in...</div>;
    case "signoutRedirect":
      return <div>Signing you out...</div>;
  }

  if (auth.isLoading) {
    return <div>Loading...</div>;
  }

  if (auth.error) {
    return <div>Oops...{auth.error.message}</div>;
  }

  return (
    <>
      {loadingHook.isLoading && (
        <div className="page-loader">
          <CircularProgress color="primary" variant="indeterminate" />
        </div>
      )}
      <Routes>
        <Route path="/" element={<Navigate to="/app" replace />} />
        <Route path="/login-callback" element={<LoginCallback />} />
        <Route path="/logout-callback" element={<LogoutCallback />} />

        <Route
          path="/app/*"
          element={
            <RequireAuth>
              <Layout />
            </RequireAuth>
          }
        />
      </Routes>
      {errorHook.errors.map((err: ErrorMessage, index: number) => (
        <Snackbar
          key={index}
          open={err.visible}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          autoHideDuration={6000}
          onClose={(_) => errorHook.hide(index)}
        >
          <Alert
            onClose={(_) => errorHook.hide(index)}
            severity="error"
            sx={{ width: "100%" }}
          >
            {err.description}
          </Alert>
        </Snackbar>
      ))}
    </>
  );
}

export default App;
